module.exports = __webpack_public_path__ + "static/media/pic2edit.11a2327f.png";